import { z } from "zod";

const optionalDate = z.coerce.date().nullable().optional();
const optionalString = z.coerce.string().nullable().optional();
const optionalNumber = z.coerce.number().nullable().optional();

export const controleEstoqueSchema = z.object({
  IdControleEstoque: optionalNumber, 
  IdCentroCusto: optionalNumber,
  Descricao:optionalString,
  
  // Extra
  NomeCentroCusto: optionalString
});

export type ControleEstoqueForm = z.infer<typeof controleEstoqueSchema>;